import {useQuery} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import {FileInfo, PDFFileInfo} from 'types/file-info';
import {PartnerSendingOrderPreviewType} from 'types/partner';
import {toCamelCase} from 'utils/object';
import {request} from 'utils/request-axios';

import {links} from './links';

export const usePartnerSendingOrderPreview = (
    partnerMid: string,
    mid: string,
) => {
    const locale = useLocale();

    return useQuery<PartnerSendingOrderPreviewType>({
        queryFn: () =>
            request({
                locale,
                url: window.Urls.api_sendingorder_item_preview_pdf(
                    partnerMid,
                    mid,
                ),
            }).then((res) => toCamelCase(res)),
        queryKey: [partnerMid, mid],
        refetchOnWindowFocus: false,
        retry: 2,
    });
};

export const useSupersendItemsFileInfo = (
    partnerMid: string,
    supersendMid: string,
) => {
    const locale = useLocale();

    return useQuery<{
        items: (FileInfo | PDFFileInfo)[];
        pageCount: number;
        recipientContactOrganizationName: string;
    }>({
        queryFn: () =>
            request({
                locale,
                url: links.supersend_items_fileinfo(partnerMid, supersendMid),
            }).then((res) => toCamelCase(res)),
        queryKey: [partnerMid, supersendMid],
        refetchOnWindowFocus: false,
        retry: 2,
    });
};
